export default interface DisciplineLegend {
  code: string;
  displayName: string;
  hexColor: string;
}

export const disciplineList: DisciplineLegend[] = [
  {
    code: "BC",
    displayName: "Bereavement Counselor",
    hexColor: "#97315D",
  },
  {
    code: "CM",
    displayName: "Case Manager",
    hexColor: "#DB005F",
  },
  {
    code: "HM",
    displayName: "Home Maker",
    hexColor: "#DC4C0B",
  },
  {
    code: "HA",
    displayName: "Hospice Aide",
    hexColor: "#0B979C",
  },
  {
    code: "MD",
    displayName: "Medical Director",
    hexColor: "#A81253",
  },
  {
    code: "NP",
    displayName: "Nurse Practitioner",
    hexColor: "#520F9A",
  },
  {
    code: "RN",
    displayName: "Registered Nurse",
    hexColor: "#7215D8",
  },
  {
    code: "LN",
    displayName: "Licensed Nurse",
    hexColor: "#9052D5",
  },
  {
    code: "SW",
    displayName: "Social Worker",
    hexColor: "#F25BA7",
  },
  {
    code: "SA",
    displayName: "Spiritual Advisor",
    hexColor: "#D4930A",
  },
  {
    code: "TL",
    displayName: "Team Lead",
    hexColor: "#D51D6D",
  },
  {
    code: "VOL",
    displayName: "Volunteer",
    hexColor: "#F6610C",
  },
  {
    code: "VC",
    displayName: "Volunteer Coordinator",
    hexColor: "#B74707",
  },
];

export const disciplineListForUnassignedVisit: DisciplineLegend[] = [
  {
    code: "HA",
    displayName: "Hospice Aide",
    hexColor: "#0B979C",
  },
  {
    code: "SN",
    displayName: "Skilled Nurse",
    hexColor: "#141E46",
  },
  {
    code: "SW",
    displayName: "Social Worker",
    hexColor: "#F25BA7",
  },
  {
    code: "SA",
    displayName: "Spiritual Advisor",
    hexColor: "#D4930A",
  },
  {
    code: "BC",
    displayName: "Bereavement",
    hexColor: "#97315D",
  },
];



// WEBPACK FOOTER //
// ./src/pages/calendar/discipline-legend.ts